import React, { useEffect, useMemo, useState } from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import CircularProgress from "@mui/material/CircularProgress";
import MDBox from "mdComponents/MDBox";
import MDTypography from "mdComponents/MDTypography";
import DashboardLayout from "components/LayoutContainers/DashboardLayout";
import DashboardNavbar from "components/Navbars/DashboardNavbar";
import Footer from "components/Footer";
import DataTable from "components/Tables/DataTable";
import locationsService from "services/locationsService";
import { useUser } from "context/UserContext";
import { Host } from "../../models/hostModel";
import { useNavigate } from "react-router-dom";
import MDInput from "mdComponents/MDInput";
import { useHostPortalContext } from "context/HostPortalContext";
import { useNavigationMessageContext } from "context/NavigationMessageContext";
import HostCard from "controls/HostCard";
import MDButton from "mdComponents/MDButton";
import LoadingSpinner from "controls/LoadingSpinner";
import AddLocationCard from "controls/AddLocationCard";
import NoLocationsCard from "controls/NoLocationsHostCard";


const HostLocations = () => {
  const { setHost } = useHostPortalContext();
  const { setMessage } = useNavigationMessageContext();
  const [locations, setLocations] = React.useState<Host[] | null>(null);
  const navigate = useNavigate();
  const { user, userCorporateAccount } = useUser();
  const [search, setSearch] = useState();

   useEffect(() => {
      setHost(null);
    }, [setHost]);
  
    useEffect(()=>{
      setMessage(`${userCorporateAccount.businessName} locations`);
      
      return () => setMessage(undefined);
    },[setMessage, userCorporateAccount]);
    
  const onSearchChange = (value) => {
    setSearch(value || undefined);
  };

  const columns = useMemo(
    () => [
      { Header: "Name", accessor: "name", align: "left", width: "30%" },
      { Header: "Address", accessor: "address", align: "left", width: "50%" },
      { Header: "Currently Open", accessor: "open", align: "center", width: "20%" },
    ],
    []
  );

  useEffect(() => {
    const fetchLocations = async (searchTerm: any) => {
      const hostLocations = await locationsService.fetchAllLocationsForUser(user.id, user.email);
      if(searchTerm && searchTerm !== ''){
            const showLocations = hostLocations.filter(a=> a.name?.toLowerCase().includes(searchTerm?.toLowerCase()));
            setLocations(showLocations);
        }
        else{
            setLocations(hostLocations);
        };
    };
    //refetch locations when search changes
    fetchLocations(search);
  }, [user.id, user.email, search]);

  const handleRowClick = (host: Host) => {
    if (!host?.id) return;
    //set the host in context
    var myHost = locations?.find((h) => h.id === host.id);
    if (!myHost) return;
    setHost(myHost);
    navigate(`/location/${host.id}`);
  };

  // Show loading indicator if locations are null
  if (!locations) {
    return (
      <DashboardLayout>
        <DashboardNavbar />
        <MDBox pt={6} pb={3}>
          <Grid container spacing={6} justifyContent="center">
            <Grid item xs={12} display="flex" justifyContent="center">
              <Card sx={{ p: 3, display: "flex", flexDirection: "column", alignItems: "center" }}>
                <LoadingSpinner title="Loading Locations..." size={30} />
              </Card>
            </Grid>
          </Grid>
        </MDBox>
        <Footer />
      </DashboardLayout>
    );
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <MDBox>
 {/* Button left / Search right */}
      <MDBox 
        display="flex" 
        justifyContent="space-between" 
        alignItems="center"
        mb={3}
      >
        <MDInput
          label="Search locations..."
          variant="outlined"
          size="small"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          
        />
      </MDBox>

              {/* Grid of host cards */}
              <Grid container spacing={3}>
                {/* Add Location card ALWAYS first */}
                <Grid item xs={12} sm={6} md={4} lg={3}>
                  <AddLocationCard />
                </Grid>

                {/* Existing locations */}
                {locations.length > 0 ? (
                  locations.map((host) => (
                    <Grid key={host.id} item xs={12} sm={6} md={4} lg={3}>
                      <HostCard
                        host={host}
                        onHostSelect={handleRowClick}
                        id={host.id}
                        hideFavoriteIcon={true}
                        imageSize="large"
                        largeDisplay={true}
                        hideActionButton={true}
                        isViewedOnHostPortal={true}
                      />
                    </Grid>
                  ))
                ) : 
                <Grid item xs={12} sm={6} md={4} lg={3}>
                  <NoLocationsCard />
                </Grid>}
              </Grid>
            </MDBox>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
};

export default HostLocations;
